import { render, staticRenderFns } from "./member_deposit_record_list.vue?vue&type=template&id=3e8d2a71&scoped=true"
import script from "./member_deposit_record_list.vue?vue&type=script&lang=js"
export * from "./member_deposit_record_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e8d2a71",
  null
  
)

export default component.exports